import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { IconTile, type IconTileTone } from '../icon-tile/IconTile';

export interface EmptyStateProps {
    title: string;
    icon?: LucideIcon;
    iconTone?: IconTileTone;
    description?: ReactNode;
    actions?: ReactNode;
    headingLevel?: 2 | 3;
    className?: string;
}

export function EmptyState({
    title,
    icon,
    iconTone = 'primary',
    description,
    actions,
    headingLevel = 2,
    className = '',
}: EmptyStateProps) {
    const Heading = headingLevel === 2 ? 'h2' : 'h3';
    return (
        <div className={`flex flex-col items-center gap-3 px-6 py-14 text-center ${className}`.trim()}>
            {icon && <IconTile icon={icon} tone={iconTone} className="mb-1" />}
            <Heading className="text-lg font-semibold text-mp-foreground">{title}</Heading>
            {description && <div className="max-w-md text-sm text-mp-muted">{description}</div>}
            {actions && <div className="mt-2 flex flex-wrap justify-center gap-2">{actions}</div>}
        </div>
    );
}
